import { render, staticRenderFns } from "./InvitieRecivedItem.vue?vue&type=template&id=32a85ea7&scoped=true&"
import script from "./InvitieRecivedItem.vue?vue&type=script&lang=js&"
export * from "./InvitieRecivedItem.vue?vue&type=script&lang=js&"
import style0 from "./InvitieRecivedItem.vue?vue&type=style&index=0&id=32a85ea7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a85ea7",
  null
  
)

export default component.exports